import React,{useState} from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import PopularBlogs from "../component/PopularBlogs/PopularBlogs"
import Header from '../component/Header/Header'
import { Helmet } from 'react-helmet'


const catagory = [
    {
        name:"All",
        num:0
    },
    {
        name:"Blog",
        num:2
    },
    {
        name:"Business",
        num:3
    },
    {
        name:"Mobile",
        num:4
    },
    {
        name:"Product",
        num:5
    },
    {
        name:"Machine Learning",
        num:6
    }
]

function Blog() {
    const [selCatagory,setSelCatagory] = useState({
        name:"All",
        num:0
    })



  return (
    <>
    <div className="home-pag">
    <Helmet>
        <title>
        Blog | Insights on Laser Therapy for Pain & Injury Recovery
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://www.mobilelasertherapy.ca/blog"
        />
        <meta
          name="description"
          content="Stay informed with Mobile Laser Therapy's blog, featuring the latest updates, health tips, and insights on laser therapy treatments for various conditions. Enhance your well-being with our expert advice."
        ></meta>
      </Helmet>
        
       <div style={{backgroundColor:"#F4FEFD"}}>
        <Header/>
        <div className='plain-hero d-flex align-items-center justify-content-center' style={{backgroundImage:"url('/images/creatives/blog-hero-bg.png')",backgroundRepeat:"no-repeat",backgroundSize:"cover",backgroundPosition:"center"}} >

            <h4 className='body-heading' style={{color:"white",textShadow:"1px white"}}>Mobile Laser Therapy Health News Blog</h4>

        </div>

       </div>
       
<div className='left-gradient'>
        <div className='blog-Catagory'>
            <div className='container'>
                {/* <div className='main-container' style={{borderRadius:"50px"}}>
                    <div 
                        className='row gy-2 main-catagory-container mx-3 mx-lg-0' 
                    >
                        {
                            catagory.map((ele)=>{
                                return(
                                <div 
                                    className={`col-xxl-2 col-lg-4  catagory-container ${ele.num == selCatagory.num ? "active" : ""} `}
                                    onClick={()=>{setSelCatagory(ele)}}    
                                >
                                    <p className='body-heading mb-0' >{ele.name}</p>
                                </div>
                                )
                            })
                        }
                        
                    </div>

                </div> */}

            </div>

        </div>
       <PopularBlogs
            selectedCatagory={selCatagory.num}
       />
 
   </div>
       
    <Footer 
      newsletterSection={false}
    />
 </div>
   </>
  )
}

export default Blog